import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './pageLoader.css';

export const PageLoader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="page-loader-overlay"
      role="status"
      aria-label={t('a11y.loader')}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.18, ease: [0.23, 1, 0.32, 1] }}
    >
      <div className="page-loader-inner">
        <span className="page-loader-monogram" aria-hidden="true">
          K · F
        </span>
        <div className="page-loader-hairline-track" aria-hidden="true">
          <div className="page-loader-hairline-bar" />
        </div>
        <span className="page-loader-brand">{t('brandName')}</span>
      </div>
    </motion.div>
  );
};

export default PageLoader;
